import 'react-nice-dates/build/style.css'
import styled from 'styled-components'
import { useState } from 'react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { DateRangePickerCalendar, START_DATE } from 'react-nice-dates'

const DateRangePickerCalendarOver = styled(DateRangePickerCalendar)`
    .nice-dates-navigation_current {
        flex-grow: 1;
        font-size: 36px;
    }
`
const DatePickerWrapper = styled.div`
    display: flex;
    flex-flow: column;
    width: 100%;
    height: fit-content;
`
const SelectedDateRange = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 15px;
    width: 100%;
    height: 44px;
    background: #F2F2F2;
    border-radius: 22px;
    margin-bottom: 22px;
    border: 1px solid #CCCCCC;

    div {
        margin: 0 4px;
    }

`

const DatePicker = ({ 
        dates = { }, 
        handleChangeInitial, 
        handleChangeFinal, 
        mobile, 
        displayRange = true,
        weekdayFormat = "eeeeee" 
    }) => {

    const [focus, setFocus] = useState(START_DATE)

    const handleFocusChange = newFocus => {
      setFocus(newFocus || START_DATE)
    }

    const handleChangeInitialDate = date => {
        handleChangeInitial({ date })
    }

    const handleChangeFinalDate = date => {
        handleChangeFinal({ date })
    }

    return (

            <DatePickerWrapper>

                { displayRange && (
                    <SelectedDateRange> 
                        {dates.initial_date ? format(dates.initial_date, 'dd/MM/yyyy', { locale: ptBR }) : ''}
                        <div> - </div>
                        {dates.final_date ? format(dates.final_date, 'dd/MM/yyyy', { locale: ptBR }) : ''}
                    </SelectedDateRange>
                )}

                <DateRangePickerCalendarOver
                    startDate={dates.initial_date }
                    endDate={dates.final_date}
                    focus={focus}
                    onStartDateChange={handleChangeInitialDate}
                    onEndDateChange={handleChangeFinalDate}
                    onFocusChange={handleFocusChange}
                    format='dd/MM/yyyy'
                    locale={ptBR}
                    weekdayFormat={weekdayFormat}
                    touchDragEnabled={mobile ? false : true}
                />
                
            </DatePickerWrapper>
    )

}

export default DatePicker